import { ShieldX } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/shared/components/empty-state';
import { Button } from '@/shared/ui/button';

export function NpsForbidden() {
  return (
    <EmptyState
      icon={ShieldX}
      title="Acesso restrito"
      description="Esta área é exclusiva para administradores NPS."
      action={
        <Button asChild variant="secondary">
          <Link to="/nps">Voltar ao início</Link>
        </Button>
      }
    />
  );
}
